export default {
  functionKey: "PETITE.VALEUR",
  title: "PETITE.VALEUR",
  group: "Calcul",
  origin: [],
  target: [],
  targetRequired: true,
  multiOrigin: true,
  arguments: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "N", name: "Rang" }],
  expectedArguments: [
    { name: "Rang", argumentKey: "N", single: true, initialValue: "1" }
  ],
  description: "Retourne la Nième plus petite valeur parmi plusieurs colonnes. Ajoutez les colonnes en Origine, le rang en Argument (1 = min).",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol, allOrigins = []) {
    const cols = allOrigins.length > 0 ? allOrigins : (origin ? [origin] : []);
    const n = args[0] || '1';
    if (cols.length === 0) return { displayCode: '', safeCode: '' };
    const safeCode = `var _pv=[${cols.join(',')}].map(function(v){return parseFloat(v);}).filter(function(v){return !isNaN(v);}).sort(function(a,b){return a-b;}); ${destination}=_pv.length>=(${n})?String(_pv[(${n})-1]):'';`;
    return { displayCode: safeCode, safeCode };
  }
}
